import { Box, Toolbar, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useStyles } from "tss-react/mui";
import { getScraperLogs } from "../../../apis/scraper_logs";
import { ScraperLogsTable } from "../components/ScraperLogsTable";

function ScraperLogs() {
	const { classes } = useStyles();

	const [logs, setLogs] = useState([]);
	const [count, setCount] = useState(0); // total rows from API
	const [page, setPage] = useState(0); // 0-based page for MUIDataTable
	const [rowsCount, setRowsCount] = useState(25); // rows per page

	useEffect(() => {
		loadProductLogs(page, rowsCount);
	}, [page, rowsCount]);

	const loadProductLogs = async (pageNumber = 0, pageSize = 10) => {
		const res = await getScraperLogs(pageNumber + 1, pageSize);

		setLogs(res.data.results.data);
		setCount(res.data.count);
	};
	const handleRowsPerPageChange = (newRowsPerPage) => {
		setRowsCount(newRowsPerPage);
		console.log(rowsCount);
		setPage(0); // reset to first page
	};

	const handlePageChange = (newPage) => {
		setPage(newPage);
	};

	return (
		<>
			<Toolbar>
				<Typography className={classes.title} variant="h4" noWrap />
			</Toolbar>
			<ToastContainer />
			<Box sx={{ px: 5 }}>
				<ScraperLogsTable
					logs={logs}
					page={page}
					rowsCount={rowsCount}
					count={count}
					handlePage={handlePageChange}
					handleRowsCount={handleRowsPerPageChange}
				/>
			</Box>
		</>
	);
}

export default ScraperLogs;
